module.exports = __webpack_public_path__ + "console/img/neutral.e1b8fbbb.png";